import { mapConfigResponse } from '../transforms/config';
import tuneInRequest from '../tuneInRequest';
export default function createConfigService(config, apiContext, applyReauth) {
    const configEndpoint = `${config.domains.opml}/config.ashx`;
    const configProxyEndpoint = `${config.domains.local}/config`;
    async function configRequest(additionalParams) {
        const { configApiOptions } = config;
        const { data, headers } = await tuneInRequest({
            method: 'get',
            url: configEndpoint,
            params: { ...additionalParams, c: configApiOptions.commands },
            disableCamelCase: true,
            transformResponse: mapConfigResponse(configApiOptions),
        }, apiContext);
        if (headers?.['set-cookie']) {
            apiContext.setCookiesFromHeaders(headers['set-cookie']);
        }
        if (data?.autoupdate?.['abtest.ids']) {
            apiContext.setAbTestIds(data.autoupdate['abtest.ids']);
        }
        return data;
    }
    function proxyConfigRequest(params) {
        return tuneInRequest({
            method: 'get',
            url: configProxyEndpoint,
            params,
            disableCamelCase: true,
        }, apiContext);
    }
    return {
        get: applyReauth(configRequest),
        proxy: proxyConfigRequest,
    };
}
